// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iMFI = 'iMFI';
export class IMFI extends iBuildInIndicator {
    constructor(mfiPeriod) {
        super(1);
        this.FMFIPeriod = 0;
        this.FPMF = new ExpandDoubleVector();
        this.FNMF = new ExpandDoubleVector();
        this.FMFIPeriod = mfiPeriod;
    }
    get Name() {
        return iMFI;
    }
    get Key() {
        return this.DefaultKey + this.FMFIPeriod;
    }
    Refresh(count, newThread) {
        this.FPMF.Dispose();
        this.FNMF.Dispose();
        this.FPMF = new ExpandDoubleVector();
        this.FNMF = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    NextBar(callBound) {
        super.NextBar(callBound);
        this.FPMF.Add(0.0);
        this.FNMF.Add(0.0);
    }
    GetSum(vector, period) {
        let summa = 0.0;
        const finish = vector.Length - period;
        for (let i = vector.Length - 1; i >= finish; i--) {
            summa += vector[i];
        }
        return summa;
    }
    OnQuote(ci, callBound, callFromRefresh = false) {
        this.FPMF[this.FPMF.Length - 1] = 0;
        this.FNMF[this.FNMF.Length - 1] = 0;
        if (!this.FParent)
            return;
        const curPrice = this.GetPrice(PriceType.Typical, 0);
        const prevPrice = this.GetPrice(PriceType.Typical, 1);
        if (curPrice > prevPrice) {
            this.FPMF[this.FCount - 1] = curPrice * this.Parent.GetVolume(this.FCount - 1);
        }
        else if (curPrice < prevPrice) {
            this.FNMF[this.FCount - 1] = curPrice * this.Parent.GetVolume(this.FCount - 1);
        }
        if (this.FCount >= this.FMFIPeriod) {
            const pmf = this.GetSum(this.FPMF, this.FMFIPeriod);
            const nmf = this.GetSum(this.FNMF, this.FMFIPeriod);
            if (nmf !== 0.0 && pmf !== -nmf) {
                this.SetValue(100.0 - 100.0 / (1.0 + pmf / nmf));
            }
            else {
                this.SetValue(100.0);
            }
        }
    }
    Dispose() {
        this.FPMF.Dispose();
        this.FNMF.Dispose();
        super.Dispose();
    }
    SetOffset(offset) {
        const ov = this.FPMF;
        const ov2 = this.FNMF;
        if (ov) {
            ov.Clear();
            ov.Offset = offset;
            ov2.Clear();
            ov2.Offset = offset;
        }
        super.SetOffset(offset);
    }
}
